export const ALLOWED_TEMPLATE_SLUGS = ["lead-capture", "employee-onboarding"];

export const TEMPLATE_IMAGE_MAP = {
  "lead-capture":
    "https://res.cloudinary.com/zapier-media/image/upload/q_auto,f_auto/v1737733171/starter-lead_capture_khk8jo.png",
  "employee-onboarding":
    "https://res.cloudinary.com/zapier-media/image/upload/q_auto,f_auto/v1737733171/starter-onboarding_ycctga.png",
};
